import {
    AppWindowIcon,
    ArrowElbowDownLeftIcon,
    ArrowElbowDownRightIcon,
    ArrowFatLinesUpIcon,
    ArrowSquareDownIcon,
    ArrowSquareOutIcon,
    ArrowSquareUpIcon,
    ArrowsOutCardinalIcon,
    ArrowsOutLineVerticalIcon,
    BellIcon,
    BellSimpleIcon,
    BluetoothIcon,
    BugBeetleIcon,
    CalendarIcon,
    CameraRotateIcon,
    CaretDownIcon,
    CaretLeftIcon,
    CaretLineRightIcon,
    CaretRightIcon,
    CaretUpIcon,
    ChartBarIcon,
    ChatCircleIcon,
    ChatDotsIcon,
    ChatSlashIcon,
    ChatsCircleIcon,
    CheckCircleIcon,
    ChecksIcon,
    CircleIcon,
    CircuitryIcon,
    ClipboardTextIcon,
    ComputerTowerIcon,
    CopyIcon,
    CopySimpleIcon,
    CrownIcon,
    CubeFocusIcon,
    CursorClickIcon,
    CursorTextIcon,
    DesktopIcon,
    DeviceMobileSpeakerIcon,
    DevicesIcon,
    DiscoBallIcon,
    DotsThreeCircleIcon,
    DownloadSimpleIcon,
    EnvelopeIcon,
    EyeIcon,
    EyeSlashIcon,
    FileMdIcon,
    FilePlusIcon,
    FilesIcon,
    FloppyDiskIcon,
    GameControllerIcon,
    GaugeIcon,
    GearFineIcon,
    GearIcon,
    GlobeIcon,
    GraduationCapIcon,
    HammerIcon,
    HandTapIcon,
    HeartStraightIcon,
    HouseIcon,
    IdentificationBadgeIcon,
    JoystickIcon,
    KeyIcon,
    KeyboardIcon,
    LaptopIcon,
    LightbulbFilamentIcon,
    LightningIcon,
    LinkBreakIcon,
    ListBulletsIcon,
    MagnifyingGlassIcon,
    MedalIcon,
    MicrophoneIcon,
    MicrophoneSlashIcon,
    MoneyIcon,
    MouseIcon,
    MouseLeftClickIcon,
    MouseMiddleClickIcon,
    MouseRightClickIcon,
    MouseScrollIcon,
    NetworkIcon,
    NetworkSlashIcon,
    NetworkXIcon,
    NotePencilIcon,
    NotebookIcon,
    NutIcon,
    OpenAiLogoIcon,
    PaletteIcon,
    PathIcon,
    PauseCircleIcon,
    PauseIcon,
    PencilSimpleIcon,
    PhoneIcon,
    PlayIcon,
    PlusCircleIcon,
    PresentationChartIcon,
    ProhibitIcon,
    QuestionIcon,
    RepeatIcon,
    RobotIcon,
    RocketLaunchIcon,
    ShareIcon,
    ShieldCheckIcon,
    ShieldStarIcon,
    SignOutIcon,
    SparkleIcon,
    SpeakerHighIcon,
    SquareHalfIcon,
    SquaresFourIcon,
    StackIcon,
    StackMinusIcon,
    StackPlusIcon,
    StopIcon,
    SwapIcon,
    TerminalWindowIcon,
    TimerIcon,
    TranslateIcon,
    TrashIcon,
    UserCircleDashedIcon,
    UserCircleGearIcon,
    UserCircleIcon,
    UserCircleMinusIcon,
    UserCirclePlusIcon,
    UsersIcon,
    UsersThreeIcon,
    WarningCircleIcon,
    WarningIcon,
    WarningOctagonIcon,
    WebcamIcon,
    WebcamSlashIcon,
    WheelchairMotionIcon,
    WifiHighIcon,
    WrenchIcon,
    XCircleIcon,
} from '@phosphor-icons/react';
import {
    Airbnb,
    Amazon,
    AmazonMusic,
    AndroidOs,
    AndroidTablet,
    AppStore,
    AppleFitness,
    AppleLogo,
    AppleNews,
    ApplePay,
    AppleTv,
    AppleWatch,
    AtlassianConfluence,
    Audible,
    Bing,
    CallOfDutyBlackOps3,
    CallOfDutyMobile,
    Chrome,
    Chromebook,
    Cnn,
    Contacts,
    CounterStrike,
    DictationPause,
    DictationPlay,
    Discord,
    DisneyMovies,
    DoomLogo,
    EduLogo,
    EduLogoWhite,
    EpicGames,
    Expression,
    EyebrowRaise,
    FaceExpression,
    Facebook,
    FacebookMessenger,
    Facetime,
    FindIphone,
    FireTv,
    Fortnite,
    Github,
    Gmail,
    GmailLogo,
    Google,
    GoogleCalendar,
    GoogleClassroom,
    GoogleDocs,
    GoogleDrawing,
    GoogleDrive,
    GoogleEarth,
    GoogleForms,
    GoogleMeet,
    GooglePixel6,
    GooglePlay,
    GooglePlayMusic,
    GooglePlus,
    GoogleSheets,
    GoogleSlides,
    Grammarly,
    HboMax,
    HeadMovement,
    HeadMovement1,
    HeadTurning,
    HeadUpAndDown,
    Health,
    Hulu,
    Icloud,
    Imovie,
    Instagram,
    IosLogo,
    IosPhotos,
    Itunes,
    JavaScript,
    Jira,
    Key0,
    Key1,
    Key2,
    Key3,
    Key4,
    Key5,
    Key6,
    Key7,
    Key8,
    Key9,
    KeyA,
    KeyAlt,
    KeyAltgr,
    KeyAsterisk,
    KeyB,
    KeyBackspace,
    KeyC,
    KeyCapsLock,
    KeyCapslockText,
    KeyCmd,
    KeyCoinsButton,
    KeyCommand,
    KeyControl,
    KeyCtrl,
    KeyD,
    KeyDelete,
    KeyDelete2,
    KeyDot,
    KeyE,
    KeyEndButton,
    KeyEnter,
    KeyEnterMac,
    KeyEqual,
    KeyEsc,
    KeyEscMac,
    KeyF,
    KeyF1,
    KeyF10,
    KeyF11,
    KeyF12,
    KeyF2,
    KeyF3,
    KeyF4,
    KeyF5,
    KeyF6,
    KeyF7,
    KeyF8,
    KeyF9,
    KeyFn,
    KeyFunctionMac,
    KeyG,
    KeyH,
    KeyHashtag,
    KeyHomeButton,
    KeyI,
    KeyJ,
    KeyK,
    KeyL,
    KeyLeftAngleParentheses,
    KeyM,
    KeyMinus,
    KeyN,
    KeyO,
    KeyOption,
    KeyP,
    KeyPageDownButton,
    KeyPageUpButton,
    KeyPlus,
    KeyQ,
    KeyR,
    KeyRightAngleParentheses,
    KeyS,
    KeySolidus,
    KeySpace,
    KeyT,
    KeyTab,
    KeyU,
    KeyV,
    KeyW,
    KeyWindows,
    KeyX,
    KeyY,
    KeyZ,
    LeanFrontToBack,
    Linkedin,
    Logo,
    Logo2KLogo,
    Mastercard,
    Messages,
    MicrosoftEdge,
    MicrosoftExcel,
    MicrosoftOnenote,
    MicrosoftOnenote2,
    MicrosoftOutlook,
    MicrosoftPowerpoint,
    MicrosoftTeams2019,
    MicrosoftToDoApp,
    MicrosoftWord,
    MotionControl,
    MotionControl1,
    MotionControl2,
    Music,
    Netflix,
    NewYorkTimes,
    NintendoSwitchLogo,
    Nod,
    Octopus,
    Office365,
    OpenCloseMouth,
    PandoraApp,
    Paypal,
    PersonalLogo,
    PersonalLogoWhite,
    Playstation,
    Playstore,
    PlusLogo,
    PlusLogoWhite,
    PowerBi,
    Preferences,
    ProLogo,
    ProLogoWhite,
    Ps4,
    ReactNative,
    Reminders,
    RockstarGames,
    Safari,
    SanAndreas,
    SdkLogo,
    SdkLogoWhite,
    SelfServiceKiosk,
    Sensitivity,
    ShakePhone,
    Shazam,
    Shift,
    Shift2,
    ShiftMac,
    Showtime,
    Sidebar,
    SignalApp,
    Siri,
    Slack,
    SmartWatch,
    Smile,
    Soundcloud,
    Spotify,
    Ssd,
    SvgCephy,
    SwitchControl,
    SwitchControl1,
    SwitchControl2,
    SwitchSimple,
    Symantec,
    TabKey2,
    TabMac,
    TapPause,
    TapPlay,
    TapStop,
    Tiktok,
    Todoist,
    ToggleKey,
    Touchpad,
    Trello,
    Tripadvisor,
    Tv,
    Twitch,
    Twitterx,
    Uber,
    Unity,
    UnrealEngine,
    Upgrade,
    Usb2,
    UsbC,
    UsbOff,
    Vector,
    VirtualApps,
    VirtualButton,
    VirtualReality,
    VisualStudio,
    Voice,
    VoiceControl,
    VoiceMemos,
    Waze,
    Weather,
    Wechat,
    Wellsfargo,
    Whatsapp,
    Windows11,
    WindowsXp,
    Xfinity,
    Yelp,
    Youtube,
    Zoom,
} from '@shared/components/core/images/icons/all/index';

export type IconName =
    | 'addRow'
    | 'ai'
    | 'airbnb'
    | 'alert'
    | 'amazon'
    | 'amazonMusic'
    | 'androidOs'
    | 'androidTablet'
    | 'presentationChart'
    | 'appStore'
    | 'appleFitness'
    | 'appleLogo'
    | 'appleNews'
    | 'applePay'
    | 'appleTv'
    | 'appleWatch'
    | 'atlassianConfluence'
    | 'audible'
    | 'automation'
    | 'award'
    | 'back'
    | 'bing'
    | 'bluetooth2'
    | 'bug'
    | 'build'
    | 'calendar'
    | 'callOfDutyBlackOps3'
    | 'callOfDutyMobile'
    | 'camera'
    | 'cameraOff'
    | 'cameraSwitch'
    | 'cancel'
    | 'cancel2'
    | 'chat'
    | 'check'
    | 'chrome'
    | 'chromebook'
    | 'circle'
    | 'close'
    | 'clipboard'
    | 'cnn'
    | 'connect'
    | 'connectionOffline'
    | 'connectionStatusOn'
    | 'communicate'
    | 'code'
    | 'compress'
    | 'collapseArrow'
    | 'computerMouse'
    | 'contacts'
    | 'counterStrike'
    | 'createOrder'
    | 'crown'
    | 'dataSecure'
    | 'delete'
    | 'deleteRow'
    | 'details'
    | 'deviceManager'
    | 'dictationOff'
    | 'dictationOn'
    | 'dictationPause'
    | 'dictationPlay'
    | 'discoball'
    | 'discord'
    | 'disneyMovies'
    | 'doomLogo'
    | 'download'
    | 'downLeftArrow'
    | 'downRightArrow'
    | 'duplicate'
    | 'edit'
    | 'eduLogo'
    | 'eduLogoWhite'
    | 'epicGames'
    | 'expandArrow'
    | 'expression'
    | 'externalLink'
    | 'eye'
    | 'eyebrowRaise'
    | 'faceExpression'
    | 'facebook'
    | 'facebookMessenger'
    | 'facetime'
    | 'fileMd'
    | 'files'
    | 'findIphone'
    | 'fireTv'
    | 'fortnite'
    | 'forward'
    | 'futures'
    | 'game'
    | 'github'
    | 'globe'
    | 'gmail'
    | 'gmailLogo'
    | 'google'
    | 'googleCalendar'
    | 'googleClassroom'
    | 'googleDocs'
    | 'googleDrawing'
    | 'googleDrive'
    | 'googleEarth'
    | 'googleForms'
    | 'googleMeet'
    | 'googlePixel6'
    | 'googlePlay'
    | 'googlePlayMusic'
    | 'googlePlus'
    | 'googleSheets'
    | 'googleSlides'
    | 'grammarly'
    | 'hboMax'
    | 'heart'
    | 'headMovement'
    | 'headMovement1'
    | 'headTurning'
    | 'headUpAndDown'
    | 'health'
    | 'help'
    | 'hide'
    | 'hideSidepanel'
    | 'home'
    | 'hub'
    | 'hulu'
    | 'icloud'
    | 'idea'
    | 'imac'
    | 'imovie'
    | 'insertRow'
    | 'insertRowAbove'
    | 'instagram'
    | 'iosLogo'
    | 'iosPhotos'
    | 'iphone'
    | 'itunes'
    | 'javaScript'
    | 'jira'
    | 'joystick'
    | 'key0'
    | 'key1'
    | 'key2'
    | 'key3'
    | 'key4'
    | 'key5'
    | 'key6'
    | 'key7'
    | 'key8'
    | 'key9'
    | 'keyA'
    | 'keyAlt'
    | 'keyAltgr'
    | 'keyAsterisk'
    | 'keyB'
    | 'keyBackspace'
    | 'keyC'
    | 'keyCapsLock'
    | 'keyCapslockText'
    | 'keyCmd'
    | 'keyCoinsButton'
    | 'keyCommand'
    | 'keyControl'
    | 'keyCtrl'
    | 'keyD'
    | 'keyDelete'
    | 'keyDelete2'
    | 'keyDot'
    | 'keyE'
    | 'keyEndButton'
    | 'keyEnter'
    | 'keyEnterMac'
    | 'keyEqual'
    | 'keyEsc'
    | 'keyEscMac'
    | 'keyF'
    | 'keyF1'
    | 'keyF10'
    | 'keyF11'
    | 'keyF12'
    | 'keyF2'
    | 'keyF3'
    | 'keyF4'
    | 'keyF5'
    | 'keyF6'
    | 'keyF7'
    | 'keyF8'
    | 'keyF9'
    | 'keyFn'
    | 'keyFunctionMac'
    | 'keyG'
    | 'keyH'
    | 'keyHashtag'
    | 'keyHomeButton'
    | 'keyI'
    | 'keyJ'
    | 'keyK'
    | 'keyL'
    | 'keyLeftAngleParentheses'
    | 'keyM'
    | 'keyMinus'
    | 'keyN'
    | 'keyO'
    | 'keyOption'
    | 'keyP'
    | 'keyPageDownButton'
    | 'keyPageUpButton'
    | 'keyPlus'
    | 'keyQ'
    | 'keyR'
    | 'keyRightAngleParentheses'
    | 'keyS'
    | 'keySolidus'
    | 'keySpace'
    | 'keyT'
    | 'keyTab'
    | 'keyU'
    | 'keyV'
    | 'keyW'
    | 'keyWindows'
    | 'keyX'
    | 'keyY'
    | 'keyZ'
    | 'keyboard'
    | 'launchpad'
    | 'layers'
    | 'leanFrontToBack'
    | 'library'
    | 'linkedin'
    | 'linkBreak'
    | 'lightning'
    | 'logo'
    | 'logo2KLogo'
    | 'logout'
    | 'macbookProM1'
    | 'mail'
    | 'mastercard'
    | 'messages'
    | 'microphone'
    | 'microphoneOff'
    | 'microsoftEdge'
    | 'microsoftExcel'
    | 'microsoftOnenote'
    | 'microsoftOnenote2'
    | 'microsoftOutlook'
    | 'microsoftPowerpoint'
    | 'microsoftTeams2019'
    | 'microsoftToDoApp'
    | 'microsoftWord'
    | 'money'
    | 'more'
    | 'motherboard'
    | 'motionControl'
    | 'motionControl1'
    | 'motionControl2'
    | 'mouse'
    | 'mouseLeftClick'
    | 'mouseMiddleClick'
    | 'mouseRightClick'
    | 'mouseScrolling'
    | 'move'
    | 'moveDown'
    | 'moveUp'
    | 'multipleDevices'
    | 'music'
    | 'naturalUserInterface2'
    | 'netflix'
    | 'newYorkTimes'
    | 'nintendoSwitchLogo'
    | 'nod'
    | 'notes'
    | 'notification'
    | 'octopus'
    | 'office365'
    | 'openCloseMouth'
    | 'orgAdmin'
    | 'orgAuthClient'
    | 'orgCompany'
    | 'orgDeleteUser'
    | 'orgInvite'
    | 'orgInviteExpired'
    | 'orgMembers'
    | 'orgPermissions'
    | 'orgTransaction'
    | 'pandoraApp'
    | 'palette'
    | 'pause'
    | 'pause2'
    | 'paypal'
    | 'personalLogo'
    | 'personalLogoWhite'
    | 'phone'
    | 'play'
    | 'playstation'
    | 'playstore'
    | 'plus'
    | 'plusLogo'
    | 'plusLogoWhite'
    | 'plusLight'
    | 'powerBi'
    | 'preferences'
    | 'preview'
    | 'previous'
    | 'proLogo'
    | 'proLogoWhite'
    | 'process'
    | 'ps4'
    | 'purchaseOrder'
    | 'reactNative'
    | 'read'
    | 'releaseKey'
    | 'reminders'
    | 'repeat'
    | 'replicateRows'
    | 'rockstarGames'
    | 'safari'
    | 'sanAndreas'
    | 'save'
    | 'sdk'
    | 'sdkLogo'
    | 'sdkLogoWhite'
    | 'search'
    | 'selfServiceKiosk'
    | 'sensitivity'
    | 'settings'
    | 'shakePhone'
    | 'share'
    | 'shazam'
    | 'shift'
    | 'shift2'
    | 'shiftMac'
    | 'showtime'
    | 'sidebar'
    | 'signalApp'
    | 'siri'
    | 'slack'
    | 'smartWatch'
    | 'smile'
    | 'soundcloud'
    | 'sparkles'
    | 'speaker'
    | 'speedometer'
    | 'spotify'
    | 'squaredMenu'
    | 'ssd'
    | 'stop'
    | 'svgCephy'
    | 'switchControl'
    | 'switchControl1'
    | 'switchControl2'
    | 'switchSimple'
    | 'symantec'
    | 'sync'
    | 'tabKey2'
    | 'tabMac'
    | 'tapPause'
    | 'tapPlay'
    | 'tapStop'
    | 'tiktok'
    | 'timer'
    | 'todoist'
    | 'toggleKey'
    | 'tools'
    | 'touchpad'
    | 'trello'
    | 'tripadvisor'
    | 'tv'
    | 'twitch'
    | 'twitterx'
    | 'uber'
    | 'unity'
    | 'unrealEngine'
    | 'upgrade'
    | 'usb2'
    | 'usbC'
    | 'usbOff'
    | 'user'
    | 'userGroups'
    | 'vector'
    | 'virtualApps'
    | 'virtualButton'
    | 'virtualReality'
    | 'visualStudio'
    | 'voice'
    | 'voiceControl'
    | 'voiceMemos'
    | 'warning'
    | 'warningFilled'
    | 'warningTriangle'
    | 'waze'
    | 'weather'
    | 'wechat'
    | 'wellsfargo'
    | 'wheelchairMotion'
    | 'whatsapp'
    | 'wiFi'
    | 'windows11'
    | 'windowsXp'
    | 'xfinity'
    | 'yelp'
    | 'youtube'
    | 'zoom'
    | 'handTap'
    | 'appWindow'
    | 'translate'
    | 'robot'
    | 'openAiLogo'
    | 'cursorClick'
    | 'cursorText';

type IconMap = {
    [key in IconName]: JSX.Element;
};

export const iconMap: IconMap = {
    handTap: <HandTapIcon />,
    cursorClick: <CursorClickIcon />,
    cursorText: <CursorTextIcon />,
    appWindow: <AppWindowIcon />,
    translate: <TranslateIcon />,
    robot: <RobotIcon />,
    openAiLogo: <OpenAiLogoIcon />,
    addRow: <StackPlusIcon />,
    ai: <CircuitryIcon />,
    airbnb: <Airbnb />,
    alert: <BellSimpleIcon />,
    amazon: <Amazon />,
    amazonMusic: <AmazonMusic />,
    presentationChart: <PresentationChartIcon />,
    androidOs: <AndroidOs />,
    androidTablet: <AndroidTablet />,
    appStore: <AppStore />,
    appleFitness: <AppleFitness />,
    appleLogo: <AppleLogo />,
    appleNews: <AppleNews />,
    applePay: <ApplePay />,
    appleTv: <AppleTv />,
    appleWatch: <AppleWatch />,
    atlassianConfluence: <AtlassianConfluence />,
    audible: <Audible />,
    automation: <GearIcon />,
    award: <MedalIcon />,
    back: <CaretLeftIcon />,
    bing: <Bing />,
    bluetooth2: <BluetoothIcon />,
    bug: <BugBeetleIcon />,
    build: <HammerIcon />,
    calendar: <CalendarIcon />,
    callOfDutyBlackOps3: <CallOfDutyBlackOps3 />,
    callOfDutyMobile: <CallOfDutyMobile />,
    camera: <WebcamIcon />,
    cameraOff: <WebcamSlashIcon />,
    cameraSwitch: <CameraRotateIcon />,
    cancel: <ProhibitIcon />,
    cancel2: <XCircleIcon />,
    chat: <ChatCircleIcon />,
    check: <CheckCircleIcon />,
    chrome: <Chrome />,
    chromebook: <Chromebook />,
    circle: <CircleIcon />,
    close: <XCircleIcon />,
    clipboard: <ClipboardTextIcon />,
    cnn: <Cnn />,
    code: <TerminalWindowIcon />,
    collapseArrow: <CaretUpIcon />,
    communicate: <ChatsCircleIcon />,
    connect: <NetworkXIcon />,
    connectionOffline: <NetworkSlashIcon />,
    connectionStatusOn: <NetworkIcon />,
    compress: <CaretLineRightIcon />,
    computerMouse: <MouseIcon />,
    contacts: <Contacts />,
    counterStrike: <CounterStrike />,
    createOrder: <FilePlusIcon />,
    crown: <CrownIcon />,
    dataSecure: <ShieldCheckIcon />,
    delete: <TrashIcon />,
    deleteRow: <StackMinusIcon />,
    details: <ListBulletsIcon />,
    deviceManager: <DevicesIcon />,
    dictationOff: <ChatSlashIcon />,
    dictationOn: <ChatDotsIcon />,
    dictationPause: <DictationPause />,
    dictationPlay: <DictationPlay />,
    discoball: <DiscoBallIcon />,
    discord: <Discord />,
    disneyMovies: <DisneyMovies />,
    doomLogo: <DoomLogo />,
    downLeftArrow: <ArrowElbowDownLeftIcon />,
    downRightArrow: <ArrowElbowDownRightIcon />,
    download: <DownloadSimpleIcon />,
    duplicate: <CopyIcon />,
    edit: <PencilSimpleIcon />,
    eduLogo: <EduLogo />,
    eduLogoWhite: <EduLogoWhite />,
    epicGames: <EpicGames />,
    expandArrow: <CaretDownIcon />,
    expression: <Expression />,
    externalLink: <ArrowSquareOutIcon />,
    eye: <EyeIcon />,
    eyebrowRaise: <EyebrowRaise />,
    faceExpression: <FaceExpression />,
    facebook: <Facebook />,
    facebookMessenger: <FacebookMessenger />,
    facetime: <Facetime />,
    fileMd: <FileMdIcon />,
    files: <FilesIcon />,
    findIphone: <FindIphone />,
    fireTv: <FireTv />,
    fortnite: <Fortnite />,
    forward: <CaretRightIcon />,
    futures: <ChartBarIcon />,
    game: <GameControllerIcon />,
    github: <Github />,
    globe: <GlobeIcon />,
    gmail: <Gmail />,
    gmailLogo: <GmailLogo />,
    google: <Google />,
    googleCalendar: <GoogleCalendar />,
    googleClassroom: <GoogleClassroom />,
    googleDocs: <GoogleDocs />,
    googleDrawing: <GoogleDrawing />,
    googleDrive: <GoogleDrive />,
    googleEarth: <GoogleEarth />,
    googleForms: <GoogleForms />,
    googleMeet: <GoogleMeet />,
    googlePixel6: <GooglePixel6 />,
    googlePlay: <GooglePlay />,
    googlePlayMusic: <GooglePlayMusic />,
    googlePlus: <GooglePlus />,
    googleSheets: <GoogleSheets />,
    googleSlides: <GoogleSlides />,
    grammarly: <Grammarly />,
    hboMax: <HboMax />,
    heart: <HeartStraightIcon />,
    headMovement: <HeadMovement />,
    headMovement1: <HeadMovement1 />,
    headTurning: <HeadTurning />,
    headUpAndDown: <HeadUpAndDown />,
    health: <Health />,
    help: <QuestionIcon />,
    hide: <EyeSlashIcon />,
    hideSidepanel: <SquareHalfIcon />,
    home: <HouseIcon />,
    hub: <NutIcon />,
    hulu: <Hulu />,
    icloud: <Icloud />,
    idea: <LightbulbFilamentIcon />,
    imac: <DesktopIcon />,
    imovie: <Imovie />,
    insertRow: <ArrowsOutLineVerticalIcon />,
    insertRowAbove: <ArrowsOutLineVerticalIcon />,
    instagram: <Instagram />,
    iosLogo: <IosLogo />,
    iosPhotos: <IosPhotos />,
    iphone: <DeviceMobileSpeakerIcon />,
    itunes: <Itunes />,
    javaScript: <JavaScript />,
    jira: <Jira />,
    joystick: <JoystickIcon />,
    key0: <Key0 />,
    key1: <Key1 />,
    key2: <Key2 />,
    key3: <Key3 />,
    key4: <Key4 />,
    key5: <Key5 />,
    key6: <Key6 />,
    key7: <Key7 />,
    key8: <Key8 />,
    key9: <Key9 />,
    keyA: <KeyA />,
    keyAlt: <KeyAlt />,
    keyAltgr: <KeyAltgr />,
    keyAsterisk: <KeyAsterisk />,
    keyB: <KeyB />,
    keyBackspace: <KeyBackspace />,
    keyC: <KeyC />,
    keyCapsLock: <KeyCapsLock />,
    keyCapslockText: <KeyCapslockText />,
    keyCmd: <KeyCmd />,
    keyCoinsButton: <KeyCoinsButton />,
    keyCommand: <KeyCommand />,
    keyControl: <KeyControl />,
    keyCtrl: <KeyCtrl />,
    keyD: <KeyD />,
    keyDelete: <KeyDelete />,
    keyDelete2: <KeyDelete2 />,
    keyDot: <KeyDot />,
    keyE: <KeyE />,
    keyEndButton: <KeyEndButton />,
    keyEnter: <KeyEnter />,
    keyEnterMac: <KeyEnterMac />,
    keyEqual: <KeyEqual />,
    keyEsc: <KeyEsc />,
    keyEscMac: <KeyEscMac />,
    keyF: <KeyF />,
    keyF1: <KeyF1 />,
    keyF10: <KeyF10 />,
    keyF11: <KeyF11 />,
    keyF12: <KeyF12 />,
    keyF2: <KeyF2 />,
    keyF3: <KeyF3 />,
    keyF4: <KeyF4 />,
    keyF5: <KeyF5 />,
    keyF6: <KeyF6 />,
    keyF7: <KeyF7 />,
    keyF8: <KeyF8 />,
    keyF9: <KeyF9 />,
    keyFn: <KeyFn />,
    keyFunctionMac: <KeyFunctionMac />,
    keyG: <KeyG />,
    keyH: <KeyH />,
    keyHashtag: <KeyHashtag />,
    keyHomeButton: <KeyHomeButton />,
    keyI: <KeyI />,
    keyJ: <KeyJ />,
    keyK: <KeyK />,
    keyL: <KeyL />,
    keyLeftAngleParentheses: <KeyLeftAngleParentheses />,
    keyM: <KeyM />,
    keyMinus: <KeyMinus />,
    keyN: <KeyN />,
    keyO: <KeyO />,
    keyOption: <KeyOption />,
    keyP: <KeyP />,
    keyPageDownButton: <KeyPageDownButton />,
    keyPageUpButton: <KeyPageUpButton />,
    keyPlus: <KeyPlus />,
    keyQ: <KeyQ />,
    keyR: <KeyR />,
    keyRightAngleParentheses: <KeyRightAngleParentheses />,
    keyS: <KeyS />,
    keySolidus: <KeySolidus />,
    keySpace: <KeySpace />,
    keyT: <KeyT />,
    keyTab: <KeyTab />,
    keyU: <KeyU />,
    keyV: <KeyV />,
    keyW: <KeyW />,
    keyWindows: <KeyWindows />,
    keyX: <KeyX />,
    keyY: <KeyY />,
    keyZ: <KeyZ />,
    keyboard: <KeyboardIcon />,
    launchpad: <RocketLaunchIcon />,
    layers: <StackIcon />,
    leanFrontToBack: <LeanFrontToBack />,
    library: <GraduationCapIcon />,
    linkedin: <Linkedin />,
    linkBreak: <LinkBreakIcon />,
    lightning: <LightningIcon />,
    logo: <Logo />,
    logo2KLogo: <Logo2KLogo />,
    logout: <SignOutIcon />,
    macbookProM1: <LaptopIcon />,
    mail: <EnvelopeIcon />,
    mastercard: <Mastercard />,
    messages: <Messages />,
    microphone: <MicrophoneIcon />,
    microphoneOff: <MicrophoneSlashIcon />,
    microsoftEdge: <MicrosoftEdge />,
    microsoftExcel: <MicrosoftExcel />,
    microsoftOnenote: <MicrosoftOnenote />,
    microsoftOnenote2: <MicrosoftOnenote2 />,
    microsoftOutlook: <MicrosoftOutlook />,
    microsoftPowerpoint: <MicrosoftPowerpoint />,
    microsoftTeams2019: <MicrosoftTeams2019 />,
    microsoftToDoApp: <MicrosoftToDoApp />,
    microsoftWord: <MicrosoftWord />,
    motionControl: <MotionControl />,
    motionControl1: <MotionControl1 />,
    motionControl2: <MotionControl2 />,
    money: <MoneyIcon />,
    more: <DotsThreeCircleIcon />,
    motherboard: <ComputerTowerIcon />,
    mouse: <MouseIcon />,
    mouseLeftClick: <MouseLeftClickIcon />,
    mouseMiddleClick: <MouseMiddleClickIcon />,
    mouseRightClick: <MouseRightClickIcon />,
    mouseScrolling: <MouseScrollIcon />,
    move: <ArrowsOutCardinalIcon />,
    moveDown: <ArrowSquareDownIcon />,
    moveUp: <ArrowSquareUpIcon />,
    multipleDevices: <DevicesIcon />,
    music: <Music />,
    naturalUserInterface2: <HandTapIcon />,
    netflix: <Netflix />,
    newYorkTimes: <NewYorkTimes />,
    nintendoSwitchLogo: <NintendoSwitchLogo />,
    nod: <Nod />,
    notes: <NotePencilIcon />,
    notification: <BellIcon />,
    octopus: <Octopus />,
    office365: <Office365 />,
    openCloseMouth: <OpenCloseMouth />,
    orgAdmin: <ShieldStarIcon />,
    orgAuthClient: <KeyIcon />,
    orgCompany: <IdentificationBadgeIcon />,
    orgDeleteUser: <UserCircleMinusIcon />,
    orgInvite: <UserCirclePlusIcon />,
    orgInviteExpired: <UserCircleDashedIcon />,
    orgMembers: <UsersIcon />,
    orgPermissions: <UserCircleGearIcon />,
    orgTransaction: <MoneyIcon />,
    pandoraApp: <PandoraApp />,
    palette: <PaletteIcon />,
    pause: <PauseIcon />,
    pause2: <PauseCircleIcon />,
    paypal: <Paypal />,
    personalLogo: <PersonalLogo />,
    personalLogoWhite: <PersonalLogoWhite />,
    phone: <PhoneIcon />,
    play: <PlayIcon />,
    playstation: <Playstation />,
    playstore: <Playstore />,
    plus: <PlusCircleIcon />,
    plusLight: <PlusCircleIcon />,
    plusLogo: <PlusLogo />,
    plusLogoWhite: <PlusLogoWhite />,
    powerBi: <PowerBi />,
    preferences: <Preferences />,
    preview: <EyeIcon />,
    previous: <CaretLeftIcon />,
    proLogo: <ProLogo />,
    proLogoWhite: <ProLogoWhite />,
    process: <PathIcon />,
    ps4: <Ps4 />,
    purchaseOrder: <NotebookIcon />,
    reactNative: <ReactNative />,
    read: <ChecksIcon />,
    releaseKey: <ArrowFatLinesUpIcon />,
    reminders: <Reminders />,
    repeat: <RepeatIcon />,
    replicateRows: <CopySimpleIcon />,
    rockstarGames: <RockstarGames />,
    safari: <Safari />,
    sanAndreas: <SanAndreas />,
    save: <FloppyDiskIcon />,
    sdk: <CubeFocusIcon />,
    sdkLogo: <SdkLogo />,
    sdkLogoWhite: <SdkLogoWhite />,
    search: <MagnifyingGlassIcon />,
    selfServiceKiosk: <SelfServiceKiosk />,
    sensitivity: <Sensitivity />,
    settings: <GearFineIcon />,
    shakePhone: <ShakePhone />,
    share: <ShareIcon />,
    shazam: <Shazam />,
    shift: <Shift />,
    shift2: <Shift2 />,
    shiftMac: <ShiftMac />,
    showtime: <Showtime />,
    sidebar: <Sidebar />,
    signalApp: <SignalApp />,
    siri: <Siri />,
    slack: <Slack />,
    smartWatch: <SmartWatch />,
    smile: <Smile />,
    soundcloud: <Soundcloud />,
    sparkles: <SparkleIcon />,
    speaker: <SpeakerHighIcon />,
    speedometer: <GaugeIcon />,
    spotify: <Spotify />,
    squaredMenu: <SquaresFourIcon />,
    ssd: <Ssd />,
    stop: <StopIcon />,
    svgCephy: <SvgCephy />,
    switchControl: <SwitchControl />,
    switchControl1: <SwitchControl1 />,
    switchControl2: <SwitchControl2 />,
    switchSimple: <SwitchSimple />,
    symantec: <Symantec />,
    sync: <SwapIcon />,
    tabKey2: <TabKey2 />,
    tabMac: <TabMac />,
    tapPause: <TapPause />,
    tapPlay: <TapPlay />,
    tapStop: <TapStop />,
    tiktok: <Tiktok />,
    timer: <TimerIcon />,
    todoist: <Todoist />,
    toggleKey: <ToggleKey />,
    tools: <WrenchIcon />,
    touchpad: <Touchpad />,
    trello: <Trello />,
    tripadvisor: <Tripadvisor />,
    tv: <Tv />,
    twitch: <Twitch />,
    twitterx: <Twitterx />,
    uber: <Uber />,
    unity: <Unity />,
    unrealEngine: <UnrealEngine />,
    upgrade: <Upgrade />,
    usb2: <Usb2 />,
    usbC: <UsbC />,
    usbOff: <UsbOff />,
    user: <UserCircleIcon />,
    userGroups: <UsersThreeIcon />,
    vector: <Vector />,
    virtualApps: <VirtualApps />,
    virtualButton: <VirtualButton />,
    virtualReality: <VirtualReality />,
    visualStudio: <VisualStudio />,
    voice: <Voice />,
    voiceControl: <VoiceControl />,
    voiceMemos: <VoiceMemos />,
    wheelchairMotion: <WheelchairMotionIcon />,
    warning: <WarningCircleIcon />,
    warningFilled: <WarningOctagonIcon />,
    warningTriangle: <WarningIcon />,
    waze: <Waze />,
    weather: <Weather />,
    wechat: <Wechat />,
    wellsfargo: <Wellsfargo />,
    whatsapp: <Whatsapp />,
    wiFi: <WifiHighIcon />,
    windows11: <Windows11 />,
    windowsXp: <WindowsXp />,
    xfinity: <Xfinity />,
    yelp: <Yelp />,
    youtube: <Youtube />,
    zoom: <Zoom />,
};
